export const pluginId = 'sentry';
